module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/zh-hant/5-b43fc7f28dd1f2579e53a180bd56c4c4.jpg";